"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _errorActions = require("../error/errorActions");
var _appActions = require("../appActions");
var _upsellActions = require("../upsell/upsellActions");
var _uiActions = require("./uiActions");
var _constants = require("../../utils/constants");
var _questionnaireActions = require("../questionnaire/questionnaireActions");
var _recommendationActions = require("../recommendation/recommendationActions");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  isLoading: false,
  loaderText: '',
  isGuidedSellingModalOpen: false,
  currentPage: _constants.PAGES.QUESTIONNAIRE,
  error: '',
  isCheckoutInProgress: false,
  timestamps: [],
  currentModalSize: 3,
  currentDynamicPage: ''
};
var uiReducer = function uiReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _uiActions.LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: payload.isLoading,
        loaderText: !payload.isLoading ? '' : state.loaderText
      });
    case _uiActions.UPDATE_LOADER_TEXT:
      return _objectSpread(_objectSpread({}, state), {}, {
        loaderText: payload.loaderText
      });
    case _questionnaireActions.END_QUESTIONNAIRE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: _constants.PAGES.SUMMARY
      });
    case _recommendationActions.GO_BACK_TO_QUESTIONNAIRE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: _constants.PAGES.QUESTIONNAIRE
      });
    case _upsellActions.GO_BACK_TO_RECOMMENDATION:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: _constants.PAGES.RECOMMENDATION
      });
    case _recommendationActions.GO_TO_UPSELL_PAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: _constants.PAGES.UPSELL
      });
    case _recommendationActions.GO_TO_COMPARISON_PAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: _constants.PAGES.COMPARISON
      });
    case _uiActions.GO_TO_DYNAMIC_PAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: _constants.PAGES.DYNAMIC
      });
    case _questionnaireActions.END_SUMMARY:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: _constants.PAGES.RECOMMENDATION
      });
    case _uiActions.SET_DYNAMIC_PAGE_CONTENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentDynamicPage: payload.contentKey
      });
    case _uiActions.OPEN_GUIDED_SELLING_MODAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        isGuidedSellingModalOpen: true
      });
    case _uiActions.CLOSE_GUIDED_SELLING_MODAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        isGuidedSellingModalOpen: false
      });
    case _appActions.INJECT_STATE:
      {
        var _payload$questionnair;
        if (((_payload$questionnair = payload.questionnaire) === null || _payload$questionnair === void 0 ? void 0 : _payload$questionnair.currentQuestionIndex) === _constants.RECOMMENDATION_PAGE_INDEX) {
          return _objectSpread(_objectSpread({}, state), {}, {
            currentPage: _constants.PAGES.RECOMMENDATION,
            timestamps: payload.timestamps || []
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          timestamps: payload.timestamps || []
        });
      }
    case _errorActions.API_CALL_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: _constants.PAGES.ERROR
      });
    case _errorActions.API_CALL_RETRY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: payload.page
      });
    case _appActions.CHECKOUT:
      return _objectSpread(_objectSpread({}, state), {}, {
        isCheckoutInProgress: true
      });
    case _appActions.CHECKOUT_ERROR:
    case _appActions.CHECKOUT_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isCheckoutInProgress: false
      });
    case _questionnaireActions.RESET_QUESTIONNAIRE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: _constants.PAGES.QUESTIONNAIRE
      });
    case _uiActions.UPDATE_TIME_STAMP:
      return _objectSpread(_objectSpread({}, state), {}, {
        timestamps: [].concat(_toConsumableArray(state.timestamps.filter(function (timestamp) {
          return timestamp.id !== payload.id;
        })), [payload])
      });
    case _uiActions.SET_MODAL_SIZE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentModalSize: payload.size
      });
    case _uiActions.GO_TO_RECOMMENDATION_ERROR_PAGE:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentPage: _constants.PAGES.RECOMMENDATION_ERROR
      });
    default:
      return state;
  }
};
var _default = uiReducer;
exports.default = _default;